/**
 * NMS Store Launch · Leadership carousel
 * The track scrolls natively (scroll-snap, touch). Arrows step one card; the
 * slide indicator thumb is sized to the visible share and follows the
 * scroll. The controls only appear when the cards overflow.
 */
(() => {
  class NMSSlLeadership extends window.NMSBaseClass {
    constructor(element, service) {
      super();
      this.element = element;
      this.sl = service;
      this.controller = new AbortController();
    }

    init() {
      super.init();
      const { track, prev, next } = this.refs;
      if (!track) return;
      const { signal } = this.controller;
      prev?.addEventListener('click', () => this.#step(-1), { signal });
      next?.addEventListener('click', () => this.#step(1), { signal });
      track.addEventListener('scroll', () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.#update();
        });
      }, { passive: true, signal });
      this.resize = new ResizeObserver(() => this.#update());
      this.resize.observe(track);
      this.#update();
    }

    #step(direction) {
      const track = this.refs.track;
      const card = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: direction * distance, behavior: this.sl.reducedMotion ? 'auto' : 'smooth' });
    }

    #update() {
      const { track, nav, prev, next, thumb } = this.refs;
      const max = track.scrollWidth - track.clientWidth;
      const overflows = max > 2;
      if (nav) nav.hidden = !overflows;
      if (!overflows) return;
      const progress = Math.min(1, Math.max(0, track.scrollLeft / max));
      const barWidth = 64;
      const thumbWidth = Math.max(16, Math.round((barWidth * track.clientWidth) / track.scrollWidth));
      thumb?.style.setProperty('--thumb', `${thumbWidth}px`);
      thumb?.style.setProperty('--offset', `${((barWidth - thumbWidth) * progress).toFixed(1)}px`);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    destroy() {
      this.controller.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.raf);
      super.destroy();
    }
  }

  const register = () => window.neemans.storeLaunch.register('[data-nms-sl-leadership]', NMSSlLeadership);
  if (window.neemans?.storeLaunch) register();
  else document.addEventListener('nms-sl:ready', register, { once: true });
})();
